import { Observable } from "rxjs";
import { HttpRequestClient, RequestOptions } from "src/infra/http/types";
import { HttpUtils } from "src/infra/http/utils";
import { injectable } from "tsyringe";

@injectable()
class FetchClient implements HttpRequestClient {
    static key = "FetchClient";
    private readonly httpUtils: HttpUtils;

    constructor() {
        this.httpUtils = new HttpUtils();
    }

    getJSON<T>(url: string, options: RequestOptions): Observable<T> {
        const { url: finalUrl, headers } = this.httpUtils.getRequestBasics(
            url,
            options
        );
        return this.httpUtils.createFetchCancellableRequest<T>({
            url: finalUrl,
            method: "get",
            body: null,
            headers,
        });
    }
    get<T>(url: string, options: RequestOptions): Observable<T> {
        const { url: finalUrl, headers } = this.httpUtils.getRequestBasics(
            url,
            options
        );
        return this.httpUtils.createFetchCancellableRequest<T>({
            url: finalUrl,
            method: "get",
            body: null,
            headers,
        });
    }
    post<T>(url: string, options: RequestOptions): Observable<T> {
        const { url: finalUrl, headers } = this.httpUtils.getRequestBasics(
            url,
            options
        );
        return this.httpUtils.createFetchCancellableRequest<T>({
            url: finalUrl,
            method: "post",
            body: options.data,
            headers,
            isFormData: options.isFormData,
        });
    }
    put<T>(url: string, options: RequestOptions): Observable<T> {
        const { url: finalUrl, headers } = this.httpUtils.getRequestBasics(
            url,
            options
        );
        return this.httpUtils.createFetchCancellableRequest<T>({
            url: finalUrl,
            method: "put",
            body: options.data as BodyInit,
            headers,
        });
    }
    delete<T>(url: string, options: RequestOptions): Observable<T> {
        const { url: finalUrl, headers } = this.httpUtils.getRequestBasics(
            url,
            options
        );
        return this.httpUtils.createFetchCancellableRequest<T>({
            url: finalUrl,
            method: "delete",
            body: null,
            headers,
        });
    }
}

export { FetchClient };
